import { getQueryString } from './environment';

let fontEl;

export function getFontEl() {
  return fontEl;
}

export default function remComputer() {
  var dpr, rem;
  var docEl = document.documentElement;
  fontEl = document.createElement('style');
  var width = docEl.clientWidth;
  var fontSize = localStorage.getItem('hlyEnlargeSetting') || 1;
  dpr = window.devicePixelRatio || 1;
  // rem = docEl.clientWidth * dpr / 10;

  if (width == 0) {
    rem = width / 10;
  } else {
    rem = 375 / 10;
  }

  rem = 375 / 10;
  // scale = 1 / dpr;
  rem = (rem / 3.75) * 10;

  // 设置viewport，进行缩放，达到高清效果
  // metaEl.setAttribute('content', 'width=' + dpr * docEl.clientWidth + ',initial-scale=' + scale + ',maximum-scale=' + scale + ', minimum-scale=' + scale + ',user-scalable=no');

  // 设置data-dpr属性，留作的css hack之用
  docEl.setAttribute('data-dpr', dpr);

  // 动态写入样式
  docEl.firstElementChild.appendChild(fontEl);
  fontEl.innerHTML = 'html{font-size:' + rem + 'px!important;}';

  if (!getQueryString('loginType') || getQueryString('loginType') === 'dd') {
    let dingTalkRem = 100 * fontSize;
    fontEl.innerHTML = 'html{font-size:' + dingTalkRem + 'px!important;}';
  }

  window.dpr = dpr;
  window.rem = rem;
}
